import { Contact, Layout } from '@rumblefish/ui/Rumblefish23Theme';

import { NextHeadWithMeta } from '../NextHeadWithMeta';
import { Benefits } from './Benefits';
import { Faq } from './Faq';
import { FintechServices } from './FintechServices';
import { fintechSoftwareDevelopmentPageSeo } from './FintechSoftwareDevelopmentPage.seo';
import type { FintechSoftwareDevelopmentProps } from './FintechSoftwareDevelopmentPage.types';
import { Hero } from './Hero';
import { OurWork } from './OurWork';
import { Testimonial } from './Testimonial';

export const FintechSoftwareDevelopmentPage = ({
  blogPosts,
  caseStudies,
}: FintechSoftwareDevelopmentProps) => {
  return (
    <Layout blogPosts={blogPosts}>
      <NextHeadWithMeta {...fintechSoftwareDevelopmentPageSeo} />

      <Hero />
      <FintechServices />
      <Testimonial />
      <Benefits />
      <OurWork caseStudies={caseStudies} />
      <Faq />
      <Contact
        subtitle="We will answer any questions you may have related to Fintech Software Development!"
        color="raspberry"
      />
    </Layout>
  );
};
